export default (value, start, end) => {
  if (start || end) {
    return value.substring(start, end)
  }

  return value.substring(0, 10)
}
